import { render, staticRenderFns } from "./ViewComplaintSuggestions.vue?vue&type=template&id=e443c284&"
import script from "./ViewComplaintSuggestions.vue?vue&type=script&lang=js&"
export * from "./ViewComplaintSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./ViewComplaintSuggestions.vue?vue&type=style&index=0&id=e443c284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports